<div class="team-picture" *ngIf="handlerPicture.handlerStatus != getHandlerStatusEnum().NON_ACTIVE && !handlerPicture.showUserImage">
  T
</div>
<div *ngIf="handlerPicture.handlerStatus != getHandlerStatusEnum().NON_ACTIVE && handlerPicture.showUserImage">
  <img [src]="userImage" class="personPhoto" (error)="updateUrl($event)"/>
</div>